module.exports = __webpack_public_path__ + "media/images/icons/arrow-thick-top-6b1b129ad8e24b4723fb358b1451f865.svg";